import { render, staticRenderFns } from "./ExercismExercise.vue?vue&type=template&id=3236456e&"
import script from "./ExercismExercise.vue?vue&type=script&lang=js&"
export * from "./ExercismExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports